import React, { useState, useEffect } from 'react';
import { NavLink, withRouter } from 'react-router-dom';

import Upload from '../../../../components/Input/Upload';
import ToastUtil from '../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../components/SweetAlert';
import LayoutContext from '../../../../store/Layout/contexts';
import { newFetch, GET, POST } from '../../../../helpers/fetch';

const AddDoc = ({ history }) => {
  const [clients, setClients] = useState([]);
  const [client, setClient] = useState(0);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [uploads, setUploads] = useState([]);

  const fetchClients = async () => {
    let api_path = `/client`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      setClients(response.data);
    }
  };

  useEffect(() => {
    fetchClients();
  }, []);

  const handleDiscard = async () => {
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to discard all changes?'
      )
    ) {
      setClient(0);
      setTitle('');
      setDescription('');
      setUploads([]);
    }
  };

  const validateForm = () => {
    if (client === 0) {
      ToastUtil.error('Please select a Client!');
      return false;
    }

    if (!title) {
      ToastUtil.error('Please input Title!');
      return false;
    }

    if (!description) {
      ToastUtil.error('Please input Description!');
      return false;
    }

    if (uploads.length <= 0) {
      ToastUtil.error('Please insert Document to Upload!');
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      validateForm() &&
      (await AlertService.confirm(
        '',
        'Are you sure you want to add this Document?'
      ))
    ) {
      let formData = new FormData();

      formData.append('client_id', client);
      formData.append('title', title);
      formData.append('description', description);
      formData.append('file', uploads[0]);

      let api_path = `/edoc`;
      let response = await newFetch(POST, api_path, formData, 'multi');

      ToastUtil.success(response.message);

      if (response.success) {
        history.push('/edocs');
      }
    }
  };

  return (
    <LayoutContext.Consumer>
      {({ activeSidebar }) => {
        return (
          <div style={{ paddingTop: '3rem' }}>
            <div
              className="d-flex flex-column"
              style={{ paddingLeft: '3rem', paddingRight: '3rem' }}
            >
              <NavLink
                to="/edocs"
                className="text-decoration-none"
                style={{ color: 'inherit' }}
              >
                <div style={{ color: '#5156BE' }}>
                  <i className="fas fa-chevron-left pe-2"></i>Back to eDocs
                </div>
              </NavLink>
              <div className="pt-4">
                <h5>Add New eDoc</h5>
              </div>
            </div>
            <form className="form" onSubmit={(e) => handleSubmit(e)}>
              <div
                style={{
                  marginTop: '2rem',
                  paddingLeft: '3rem',
                  paddingRight: '3rem',
                }}
              >
                <div className="d-flex border rounded">
                  <div
                    style={{
                      width: '15rem',
                      backgroundColor: '#f3f3f3',
                      padding: '2.25rem',
                    }}
                    className="border-right"
                  >
                    <strong>eDoc Information</strong>
                    <p className="pt-2">Manage eDocs information</p>
                  </div>
                  <div
                    className="flex-grow-1 bg-white"
                    style={{ padding: '2.25rem' }}
                  >
                    <div className="row pb-3">
                      <strong>Client*</strong>
                      <select
                        name="client"
                        className="form-select mt-3 w-50 adjust-fs"
                        value={client}
                        onChange={(e) => setClient(e.target.value)}
                      >
                        <option value={0}>Select Client</option>
                        {clients &&
                          clients.map((client) => (
                            <option key={client.id} value={client.id}>
                              {client.name}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="row pb-3">
                      <strong>Title*</strong>
                      <input
                        type="text"
                        className="form-control mt-3 adjust-fs"
                        placeholder="Title"
                        value={title}
                        onChange={({ target: { value } }) => setTitle(value)}
                      />
                    </div>
                    <div className="row pb-3">
                      <strong>Description*</strong>
                      <textarea
                        rows="10"
                        className="form-control mt-3 adjust-fs"
                        style={{ resize: 'none' }}
                        placeholder="Description"
                        value={description}
                        onChange={({ target: { value } }) =>
                          setDescription(value)
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  marginTop: '2rem',
                  paddingLeft: '3rem',
                  paddingRight: '3rem',
                  paddingBottom: '6rem',
                }}
              >
                <div className="d-flex border rounded">
                  <div
                    style={{
                      width: '15rem',
                      backgroundColor: '#f3f3f3',
                      padding: '2.25rem',
                    }}
                    className="border-right"
                  >
                    <strong>Upload File</strong>
                    <p className="pt-2">Manage eDocs file upload</p>
                  </div>
                  <div
                    className="flex-grow-1 bg-white"
                    style={{ padding: '2.25rem' }}
                  >
                    <div className="row pb-3">
                      <Upload
                        files={uploads}
                        setFiles={setUploads}
                        multiple={false}
                        accept={'application/pdf'}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  position: 'fixed',
                  bottom: 0,
                  width: activeSidebar ? 'calc(100vw - 310px)' : '100vw',
                  height: '4.5rem',
                  paddingRight: '3rem',
                }}
                className="border-top bg-white d-flex align-items-center justify-content-end"
              >
                <button
                  type="button"
                  className="btn btn-outline-brand adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                  onClick={handleDiscard}
                >
                  Discard
                </button>
                <button
                  type="submit"
                  className="btn btn-brand ms-3 adjust-fs adjust-shadow"
                  style={{ width: '12rem' }}
                >
                  Save changes
                </button>
              </div>
            </form>
          </div>
        );
      }}
    </LayoutContext.Consumer>
  );
};

export default withRouter(AddDoc);
